import auth from "./auth";
import _ from "lodash";
import merchantModule from "../modules/merchants";

const getPlanModuleCodes = () => {
    const { moduleList } = merchantModule.state;
    let planModuleCodes = [];

    if (moduleList) {
        const submoduleList = [];

        for (const module of moduleList) {
            const { submodules } = module;

            submoduleList.push(submodules.map(submodule => submodule.code));
        }
        planModuleCodes = [].concat.apply([], submoduleList);
    }

    return planModuleCodes;
};

const getSubmoduleName = (code) => {
    let submodules = [];
    const { moduleList } = merchantModule.state;

    moduleList.forEach(module => {
        submodules = [...submodules, ...module.submodules];
    });

    return _.get(submodules.find((submodule) => submodule.code === code), "name", "")
};

export default {
    getPlanModuleCodes,
    getSubmoduleName,
    hasAccess(module) {
        if (!module || typeof module !== "string") return false;

        const permissionsToBeRemoved = ["mechanics.design"];
        const modulePermissionCodes = auth
            .getModuleAccess()
            .filter(item => !permissionsToBeRemoved.includes(item));
        const planModuleCodes = getPlanModuleCodes();
        const user = auth.getUser();
        const isModuleIncludedInPlan = planModuleCodes.indexOf(module) !== -1;
        const hasPermission = modulePermissionCodes.indexOf(module) !== -1;
        const topups = auth.getEnabledTopUps();

        if (module === "engagement.survey" || module === "customer.stores") {
            if (user.role === "admin")
                return isModuleIncludedInPlan && topups.includes("reports");

            return (
                hasPermission &&
                isModuleIncludedInPlan &&
                topups.includes("reports")
            );
        }

        if (module === "mechanics.privilege-card") {
            const isIncludedInPlanAndTopups =
                isModuleIncludedInPlan && topups.includes("privilege_card");

            if (user.role === "admin") return isIncludedInPlanAndTopups;

            return isIncludedInPlanAndTopups && hasPermission;
        }

        if (module.includes("s-wallet")) {
            const isIncludedInPlanAndTopups =
                isModuleIncludedInPlan && topups.includes("wallet");

            if (user.role === "admin") return isIncludedInPlanAndTopups;

            return isIncludedInPlanAndTopups && hasPermission;
        }

        if (module.includes(":topup")) {
            let topup = module.split(":topup-")[1];

            if (topup === "customers.whitelist") topup = "whitelist";

            if (topup === "vouchers") topup = "voucher";

            if (user.role === "admin")
                return isModuleIncludedInPlan && topups.includes(topup);

            return (
                hasPermission &&
                isModuleIncludedInPlan &&
                topups.includes(topup)
            );
        }

        if (user.role === "admin") return isModuleIncludedInPlan;

        return hasPermission && isModuleIncludedInPlan;
    },
    isTopUpEnable(module) {
        if (auth.getUser().role === "admin") {
            return true;
        }
        return auth.getEnabledTopUps().indexOf(module) !== -1;
    },
    showSideBarIcon(sidebarModule) {
        let moduleIcon = _.findIndex(auth.getModuleAccess(), function(data) {
            return data.includes(sidebarModule + ".");
        });
        return moduleIcon !== -1;
    }
};
